import { DEFAULT_IMAGE_LIMIT_SIZE, IMAGE_TYPES, MAX_LENGTH_LINK } from '@/configs/constants';
import { TFunction } from 'i18next';

// #region  Url
export const validateUrl = (value): boolean => {
    if (!value) {
        return true;
    }

    if (typeof value !== 'string') {
        return false;
    }

    // Check for full-width characters (U+FF00 to U+FFFF)
    if (/[\uFF00-\uFFFF]/.test(value)) {
        return false;
    }

    if (value.length > MAX_LENGTH_LINK) {
        return false;
    }

    try {
        // const url = new URL(value?.trim());
        // if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        //     return false;
        // }
        // Check if the URL starts with http:// or https://
        if (!value?.trim().match(/^https?:\/\//)) {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
};
// #endregion Url

// #region Image
export const validateImageFile = (file, t: TFunction, maxSizeMB = DEFAULT_IMAGE_LIMIT_SIZE) => {
    if (!file) {
        return { isValid: false, error: t('messages.please_select_an_image_file') };
    }

    const fileExtension = file.name?.split('.')?.pop()?.toLowerCase();
    if (!fileExtension || !IMAGE_TYPES.EXTENSIONS?.includes(fileExtension)) {
        return { isValid: false, error: t('messages.only_upload_image_type') };
    }

    if (!IMAGE_TYPES.TYPE?.[file.type]) {
        return { isValid: false, error: t('messages.only_upload_image_type') };
    }

    const maxSizeBytes = maxSizeMB * 1024 * 1024;
    if (file.size > maxSizeBytes) {
        return { isValid: false, error: t('messages.exceed_size_limit', { size: maxSizeMB }) };
    }

    return { isValid: true };
};
// #endregion Image
